import React, { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next";
import '../../../assets/css/common.css';
import { AssignmentType } from "../../../api/Inventory/Entities/InventoryEntities";
import KitDispenseForm from "../../Inventory/Shared/KitDispenseForm";
import useInventoryCart from "../../Inventory/Hooks/useInventoryCart";
import { DestinationType, MoveTypes } from "../../../api/Inventory/Entities/InventoryMovementEntities";
import Loader from "../../../components/Common/Loader";
import { InventoryItemCart } from "../../Inventory/Shared/InventoryItemCart";
import { moveCartActionsStyle, moveCartPanelStyle, moveCartScrollStyle } from "../../Inventory/Shared/moveCartLayout";
import { useHistory } from "react-router-dom"
import { ProtocolSection, protocolSectionTarget } from '../../Inventory/Pages/moveDetailNavigation';
import AutoCompletation from "../../../components/Common/AutoCompletation";
import { searchPatients } from "../../../api/database";
import { Tooltip } from "../../../components/Utils/Tooltips";
import { Remove } from "../../../components/Icons/Icons";
import useOperationConfirmation from "../../Inventory/Hooks/useOperationConfirmation";
import { useUnsavedChangesPrompt } from "../../../components/Navigation/useUnsavedChangesPrompt";
import { CustomSelect } from "../../../components/CustomControls/CustomSelect";
import useVisitsTracking from "../../Inventory/Hooks/useVisitsTracking";
import { EnumValue } from "../../../api/Freezer/Entities/Utils";
import moment from "moment";
import { canClearSelection } from "../../Inventory/Shared/inventoryFormRules";

export default function ProtocolDispenseRequestForm({ match: { params } }) {
    const { t } = useTranslation();
    const history = useHistory();
    const [move, isMoveLoading, actions] = useInventoryCart(0, MoveTypes.ProtocolDispenseRequest.Name, AssignmentType.Protocol.Name, params.protocolId, null, null, { persistDraft: true, history })
    const { protocolId } = params;
    const [Modal, confirmActions] = useOperationConfirmation();
    const [selectedPatient, setSelectedPatient] = useState(null)
    const [visits, areVisitsLoading, visitActions] = useVisitsTracking({ mapping: v => new EnumValue(v.id, `${v.title}`) })
    const [selectedVisit, setSelectedVisit] = useState(null)
    const patientRef = useRef(null)
    const { confirmLeave, allowNavigation } = useUnsavedChangesPrompt(move.items.length > 0, history, actions.DiscardDraft)

    useEffect(() => {
        if (selectedPatient == null) {
            visitActions.clear();
            return;
        }

        const protocolData = selectedPatient.protocols.find(p => p.id == protocolId);

        visitActions.search(protocolId, protocolData?.numberInProtocol);
    }, [selectedPatient != null])

    function handleNewItem(item) {
        actions.AddItem(item.item, item.release, item.quantity, item.assignment, item.availableQuantity)
    }
    function onDeleteItem(item, _) {
        actions.RemoveItem(item)
    }
    function handleItemChange(quantity, item) {
        actions.UpdateQuantity(item, quantity)
    }

    function onHandleCancel() {
        if (!confirmLeave()) return
        history.push(protocolSectionTarget(protocolId, ProtocolSection.inventory))
    }

    async function onHandleSubmit() {
        await confirmActions.saveDispenseAsPeding({
            patient: selectedPatient,
            destinationType: DestinationType.ProtocolPatient,
            patientVisitId: selectedVisit.Value,
            move: move,
            succeededCallback: () => { allowNavigation(); history.push(protocolSectionTarget(protocolId, ProtocolSection.inventory)) }
        })
    }

    const fetchPatients = async (term) => {
        const result = (await searchPatients(term))
            .data
        //Filtro por los asignados a este protocolo
        return result.filter(p => p.protocols.filter(pp => pp.id == protocolId).length > 0);
    }

    const curringSelected = (callback) => {
        return (selected) => {
            if (selected != null && selected.length > 0) callback(selected[0])
            else callback(null)
        }
    }

    const clearPatient = () => {
        setSelectedPatient(null)
        patientRef.current.clear()
        clearVisit()
    }

    const clearVisit = () => {
        setSelectedVisit(null)
    }

    const isPatientClearable = canClearSelection({ hasSelection: selectedPatient != null, cartItemCount: move.items.length })
    const isVisitClearable = canClearSelection({ hasSelection: selectedVisit != null, cartItemCount: move.items.length })

    return (<>
        <Loader isLoading={isMoveLoading}>
            <div className='max-width-1500 margin-center'>
                <div className='container-fluid form-container' style={{ fontWeight: "bolder" }}>
                    <h5><strong>{t('inventory.dispense.protocolDispenseRequestTitle')}</strong></h5>
                </div>
                <div className='container-fluid form-container'>
                    <div className='right-side' style={{ height: 'max-content', width: '35%' }}>
                        <div style={{ display: 'flex', gap: "1rem", marginBottom: '1rem' }}>
                            <div style={{ width: '100%' }}>
                                <AutoCompletation
                                    id={'Paciente'}
                                    ref={patientRef}
                                    labelKey={(option) => {
                                        return `${option.fullName} (${option.medicalRecordNumber})`;
                                    }}
                                    placeholder={t('commons.patient')}
                                    disabled={selectedPatient != null}
                                    fetchOptions={fetchPatients}
                                    onChange={curringSelected(setSelectedPatient)}
                                />
                            </div>
                            <div>
                                <button className="btn btn-danger" disabled={!isPatientClearable} onClick={clearPatient}>
                                    <Tooltip tooltip={t('commons.clear')} id={"tooltipedit-limpiarpaciente"}>
                                        <span aria-hidden="true"><Remove /></span>
                                    </Tooltip>
                                </button>
                            </div>
                        </div>
                        <hr />
                        <div style={{ display: 'flex', gap: "1rem", marginBottom: '1rem' }}>
                            <div style={{ width: '100%' }}>
                                <Loader isLoading={areVisitsLoading} small={true}>
                                    <CustomSelect
                                        value={selectedVisit}
                                        name="patient-visit"
                                        placeholder={t("commons.visit")}
                                        onChange={(e, v) => { setSelectedVisit(v) }}
                                        options={visits}
                                        getOptionLabel={(option) => option?.Name}
                                        getOptionValue={(option) => option?.Value}
                                        isDisabled={selectedPatient == null || selectedVisit != null}
                                    />
                                </Loader>
                            </div>
                            <div>
                                <button className="btn btn-danger" disabled={!isVisitClearable} onClick={clearVisit}>
                                    <Tooltip tooltip={t('commons.clear')} id={"tooltipedit-limpiarpaciente"}>
                                        <span aria-hidden="true"><Remove /></span>
                                    </Tooltip>
                                </button>
                            </div>
                        </div>
                        <hr />

                        <KitDispenseForm assignmentType={AssignmentType.Protocol.Name} assignId={protocolId} disabled={selectedVisit == null} handleSubmit={handleNewItem} />
                    </div>
                    <div className='left-side' style={moveCartPanelStyle}>
                        <div style={moveCartScrollStyle}>
                            <InventoryItemCart items={move.items} onDeleteItem={onDeleteItem} onItemsChange={handleItemChange}
                                extraColumns={[{
                                    title: 'KIT', width: '9.375rem', formatter: (index, row) => row.assignment.kitNumber
                                }]}
                                showExpirationWarning={true} />
                        </div>

                        <div style={moveCartActionsStyle}>
                            <button className='btn btn-secondary ml-1' style={{ marginRight: '1rem' }} onClick={onHandleCancel}>{t('buttons.cancel')}</button>
                            <button className='btn btn-success' disabled={!(move.items.length > 0)} onClick={onHandleSubmit}>{t('buttons.finish')}</button>
                        </div>
                    </div>
                </div>
            </div>
        </Loader>
        <Modal />
    </>)
}